import React from 'react';
import Select from 'react-select';

const SearchableDropdown = ({
  options,
  value,
  onChange,
  placeholder = 'Select an option',
  isLoading = false,
  error,
}) => {
  return (
    <div className="mb-4 w-full">
      <Select
        options={options}
        value={value}
        onChange={(selectedOption) => onChange(selectedOption)}
        placeholder={placeholder}
        isLoading={isLoading}
        className="basic_multi_select dark:bg-[#4c5972] dark:text-white bg-white text-black"
        classNamePrefix="select"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: 'transparent',
            color: 'inherit',
            borderColor: '#cbd2d9',
            borderRadius: '0.375rem',
            padding: '0.3rem 0.3rem',
            fontSize: '1rem',
            boxShadow: 'none',
            ':hover': {
              borderColor: '#adb5bd',
            },
            ':focus-within': {
              border: '2px solid #000',
            },
          }),
          menu: (provided) => ({
            ...provided,
            backgroundColor: 'dark:#4c5972 white',
            color: 'dark:white black',
            borderRadius: '0.375rem',
            marginTop: '4px',
          }),
          option: (provided, state) => ({
            ...provided,
            padding: '0.50rem 1.25rem',
            fontSize: '1rem',
            backgroundColor: state.isFocused ? '#e2e8f0' : '#ffffff',
            color: state.isFocused ? 'black' : 'black',
            cursor: 'pointer',
          }),

          placeholder: (provided) => ({
            ...provided,
            color: '#adb5bd',
            fontSize: '1rem',
          }),
          singleValue: (provided) => ({
            ...provided,
            color: 'inherit',
            size: '1rem',
          }),
          input: (provided) => ({
            ...provided,
            color: 'inherit',
          }),
        }}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default SearchableDropdown;
